var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty flex flex_justify-center flex_align-items"},[_c('i',{staticClass:"el-icon-warning",staticStyle:{"font-size":"50px","color":"#999"}}),_c('p',[_vm._v("暂无培训课程")])])
}]

export { render, staticRenderFns }